export default __webpack_public_path__ + "static/media/triangle-light.5ffd295b.svg";